export function checkForDocumentFailures({
  attemptsImages,
  documentType,
}: {
  attemptsImages:
    | {
        image: string;
        inserted_at: string;
        reason: string;
        type: string;
      }[]
    | null;
  documentType?: "passport" | "license";
}):
  | "documents_failed"
  | "documents_have_failure"
  | "selfie_has_failure"
  | null {
  const previousAttempts = attemptsImages
    ? attemptsImages.reduce(
        (res: any, attempt: any) => {
          res[attempt.type]++;
          return res;
        },
        { front: 0, back: 0, selfie: 0 }
      )
    : { front: 0, back: 0, selfie: 0 };

  if (previousAttempts.selfie === 1) {
    return "selfie_has_failure";
  }

  if (documentType === "passport") {
    if (previousAttempts.front >= 2 || previousAttempts.selfie >= 2) {
      return "documents_failed";
    }

    if (previousAttempts.front === 1) {
      return "documents_have_failure";
    }
  } else {
    if (
      previousAttempts.front >= 2 ||
      previousAttempts.back >= 2 ||
      previousAttempts.selfie >= 2
    ) {
      return "documents_failed";
    }

    if (previousAttempts.front === 1 || previousAttempts.back === 1) {
      return "documents_have_failure";
    }
  }

  return null;
}

export function parseAttempts(
  attemptsImages:
    | {
        image: string;
        inserted_at: string;
        reason: string;
        type: string;
      }[]
    | null
): { front: number; back: number; selfie: number } {
  return attemptsImages
    ? attemptsImages.reduce(
        (res: any, attempt: any) => {
          res[attempt.type]++;
          return res;
        },
        { front: 0, back: 0, selfie: 0 }
      )
    : { front: 0, back: 0, selfie: 0 };
}
